import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=9cc08ace&scoped=true&"
import script from "./comment.js?vue&type=script&lang=js&"
export * from "./comment.js?vue&type=script&lang=js&"
import style0 from "./comment.scss?vue&type=style&index=0&id=9cc08ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc08ace",
  null
  
)

export default component.exports